export const VERIFICATION_CODE = 'BrusselsAir';
